export const getImageURL = (_metadata) => {
    // TEMP
    var parts = _metadata.image.split('/');
    const id = parts.pop() || parts.pop();
    return `/img/nft/${id}`;
    // END TEMP
    if (_metadata.image == undefined)
        return "";
    if (_metadata.image.startsWith("ipfs://"))
        return _metadata.image.replace("ipfs://", "https://ipfs.io/ipfs/");
    if (!_metadata.image.startsWith("https://"))
        return `https://${_metadata.image}`;
    return _metadata.image;
};
